/**
 * Report Service
 * API calls for report management
 */

import { apiClient } from './apiClient';
import { Report, ReportTemplate, ReportStats, ReportFilters } from '../types/report';

export const reportService = {
  /**
   * Get all reports with optional filtering
   */
  async getReports(filters?: ReportFilters): Promise<{ reports: Report[]; count: number }> {
    const params = new URLSearchParams();
    
    if (filters?.type && filters.type !== 'all') params.append('type', filters.type);
    if (filters?.status && filters.status !== 'all') params.append('status', filters.status);
    if (filters?.landlordId && filters.landlordId !== 'all') params.append('landlordId', filters.landlordId);
    if (filters?.limit) params.append('limit', String(filters.limit));

    const response = await apiClient.get(`/getAdminReports?${params.toString()}`);
    return response.data;
  },

  /**
   * Get report statistics
   */
  async getReportStats(): Promise<{ stats: ReportStats }> {
    const response = await apiClient.get('/getAdminReportStats');
    return response.data;
  },

  /**
   * Get available report templates
   */
  async getTemplates(): Promise<{ templates: ReportTemplate[]; count: number }> {
    const response = await apiClient.get('/getReportTemplates');
    return response.data;
  },

  /**
   * Create a new report
   */
  async createReport(reportData: Partial<Report>): Promise<{ reportId: string }> {
    const response = await apiClient.post('/createAdminReport', reportData);
    return response.data;
  },

  /**
   * Generate a report
   */
  async generateReport(reportId: string): Promise<{ success: boolean; message: string }> {
    const response = await apiClient.post('/generateAdminReport', { reportId });
    return response.data;
  },

  /**
   * Delete a report
   */
  async deleteReport(reportId: string): Promise<{ success: boolean; message: string }> {
    const response = await apiClient.post('/deleteAdminReport', { reportId });
    return response.data;
  },
};
